import React from 'react';
import {Navigate, RouteObject, useRoutes} from 'react-router-dom';
import {RouteUrl} from "@app/constants/routeUrl";
import BrandDashboardShopOperationStateMobilePage
    from "@contents/mobile/layoutPages/brands/dashboard/shopOperationStateMobilePage";

const SingleLayout = React.lazy(() => import('@contents/layouts/singleLayout'));
const InitPage = React.lazy(() => import('./contents/pages/init'));
const LoginPage = React.lazy(() => import('./contents/pages/login'));
const PasswordChangePage = React.lazy(() => import('./contents/pages/passwordChange'));
const InvitePate = React.lazy(() => import('./contents/pages/invite'));
const SignupPage = React.lazy(() => import('./contents/pages/signup'));
const SignupCompletePage = React.lazy(() => import('./contents/pages/signupComplete'));

const LandingPage = React.lazy(() => import('./contents/pages/landing'));

const BaseLayout = React.lazy(() => import('@contents/layouts/baseLayout'));

const SideBarLayout = React.lazy(() => import('@contents/layouts/sideBarLayout'));

const MyShop = React.lazy(() => import('./contents/applications/myShop'));
const MyMenu = React.lazy(() => import('./contents/applications/myMenu'));

const CommonNoticeDetailPage = React.lazy(() => import('./contents/applications/board'));
// const MyMenu = React.lazy(() => import('./contents/applications/myMenu'));

const OperationDashboard = React.lazy(() => import('./contents/layoutPages/operations/dashboard'));
// const OperationSpacePage = React.lazy(() => import('./contents/layoutPages/operations/space'));
const OperationSpaceContextPage = React.lazy(() => import('@contents/layoutPages/operations/contextLayer/spaceContextPage'));
const OperationSpaceBrandListPage = React.lazy(() => import('./contents/layoutPages/operations/space/spaceBrandList'));
const OperationSpaceTabPage = React.lazy(() => import('./contents/layoutPages/operations/space/spaceTab'));
const OperationSpaceBrandEditPage = React.lazy(() => import('@contents/layoutPages/operations/space/brand/brandEdit'));
const OperationSpaceShopEditPage = React.lazy(() => import('@contents/layoutPages/operations/space/shop/shopEdit'));
const OperationSpaceDeviceEditPage = React.lazy(() => import('@contents/layoutPages/operations/space/device/deviceEdit'));

// const OperationPersonnelEmployeePage = React.lazy(() => import('./contents/layoutPages/operations/personnel/employee'));
const OperationPersonnelEmployeeBrandPage = React.lazy(() => import('./contents/layoutPages/operations/personnel/employee/employeeBrandList'));
const OperationPersonnelEmployeeHistoryPage = React.lazy(() => import('@contents/layoutPages/operations/personnel/employee/employeeHistoryList'));
const OperationStatisticPage = React.lazy(() => import('./contents/layoutPages/operations/statisticsLog/statistic'));
const OperationLogPage = React.lazy(() => import('./contents/layoutPages/operations/statisticsLog/log'));
// const OperationRemotePage = React.lazy(() => import('./contents/layoutPages/operations/system/remote'));
const OperationRemoteBrandListPage = React.lazy(() => import('@contents/layoutPages/operations/system/remote/BrandList'));
const OperationRemoteDeviceListPage = React.lazy(() => import('@contents/layoutPages/operations/system/remote/deviceList'));
const OperationRemoteDeviceDetailPage = React.lazy(() => import('@contents/layoutPages/operations/system/remote/deviceDetail'));

const OperationDistributePage = React.lazy(() => import('@/contents/layoutPages/operations/system/distribute/index'));
// const OperationDistributeSpaceListPage = React.lazy(() => import('@/contents/layoutPages/operations/system/distribute/manage/index'));
const OperationDistributeBrandListPage = React.lazy(() => import('@/contents/layoutPages/operations/system/distribute/manage/brandList'));
const OperationDistributeDeviceListPage = React.lazy(() => import('@/contents/layoutPages/operations/system/distribute/manage/deviceList'));
const OperationFileEditPage = React.lazy(() => import('@/contents/layoutPages/operations/system/distribute/file/fileEdit'));

const OperationFailurePage = React.lazy(() => import('./contents/layoutPages/operations/system/failure'));
const OperationNoticePage = React.lazy(() => import('./contents/layoutPages/operations/board/notice'));
const OperationNoticeEditPage = React.lazy(() => import('./contents/layoutPages/operations/board/notice/noticeEdit'));
const OperationManualPage = React.lazy(() => import('./contents/layoutPages/operations/board/manual'));
const OperationManualEditPage = React.lazy(() => import('./contents/layoutPages/operations/board/manual/manualEdit'));
const OperationStoragePage = React.lazy(() => import('./contents/layoutPages/operations/setting/storage'));

const BrandDashboard = React.lazy(() => import('./contents/layoutPages/brands/dashboard'));
const BrandDashboardCompanyStatePage = React.lazy(() => import('./contents/layoutPages/brands/dashboard/companyStatePage'));
const BrandDashboardShopOperationStatePage = React.lazy(() => import('./contents/layoutPages/brands/dashboard/shopOperationStatePage'));
const BrandDashboardNoticePage = React.lazy(() => import('./contents/layoutPages/brands/dashboard/noticePage'));
const BrandDashboardManualPage = React.lazy(() => import('./contents/layoutPages/brands/dashboard/manualPage'));

const BrandEmployeePage = React.lazy(() => import('./contents/layoutPages/brands/personnel/employee'));
const BrandEmployeeContextPage = React.lazy(() => import('@contents/layoutPages/brands/personnel/employee/contextLayer/employeeContextPage'));
const BrandEmployeeExcelValidatePage = React.lazy(() => import('./contents/layoutPages/brands/personnel/employee/list/EmployeeExcelMappingList'));
const BrandExternalPage = React.lazy(() => import('./contents/layoutPages/brands/personnel/external'));
const BrandExternalEditPage = React.lazy(() => import('./contents/layoutPages/brands/personnel/external/externalEdit'));
const BrandQrIdCardPage = React.lazy(() => import('./contents/layoutPages/brands/personnel/qr'));
const BrandSaleStatisticsPage = React.lazy(() => import('./contents/layoutPages/brands/sale/saleStatistics'));
const BrandEmployeeStatisticsPage = React.lazy(() => import('./contents/layoutPages/brands/sale/employeeStatistics'));
const BrandPointManagePage = React.lazy(() => import('./contents/layoutPages/brands/pointSystem/manage'));
const BrandPointEmployeeDetailPage = React.lazy(() => import('@contents/layoutPages/brands/pointSystem/manage/employee/EmployeeDetail'));
// const BrandPointUseStatisticsPage = React.lazy(() => import('./contents/layoutPages/brands/pointSystem/useStatistics'));
const BrandPointHistoryDetailPage = React.lazy(() => import('@contents/layoutPages/brands/pointSystem/manage/history/HistoryDetail'));
const BrandPointHistoryManualPage = React.lazy(() => import('@contents/layoutPages/brands/pointSystem/manage/history/HistoryManual'));
const BrandPointHistoryExcelPage = React.lazy(() => import('@contents/layoutPages/brands/pointSystem/manage/history/HistoryExcel'));
const BrandPointSettingPage = React.lazy(() => import('./contents/layoutPages/brands/pointSystem/setting'));
const BrandCouponPage = React.lazy(() => import('./contents/layoutPages/brands/couponSystem/coupon'));
const BrandCouponUseStatisticsPage = React.lazy(() => import('./contents/layoutPages/brands/couponSystem/useStatistics'));
const BrandCouponSettingPage = React.lazy(() => import('./contents/layoutPages/brands/couponSystem/setting'));
const BrandStampPage = React.lazy(() => import('./contents/layoutPages/brands/stampSystem/stamp'));
const BrandStampUseStatisticsPage = React.lazy(() => import('./contents/layoutPages/brands/stampSystem/useStatistics'));
const BrandStampSettingPage = React.lazy(() => import('./contents/layoutPages/brands/stampSystem/setting'));
const BrandBoardPage = React.lazy(() => import('./contents/layoutPages/brands/board/board'));
const BrandBoardEditPage = React.lazy(() => import('./contents/layoutPages/brands/board/board/boardEdit'));
const BrandSurveyPage = React.lazy(() => import('./contents/layoutPages/brands/board/survey'));
const BrandSurveyDetailPage = React.lazy(() => import('./contents/layoutPages/brands/board/survey/surveyDetail'));
const BrandSurveyEditPage = React.lazy(() => import('./contents/layoutPages/brands/board/survey/surveyEdit'));
const BrandTermsPage = React.lazy(() => import('./contents/layoutPages/brands/board/terms'));
const BrandTermsEditPage = React.lazy(() => import('./contents/layoutPages/brands/board/terms/termsEdit'));
const BrandMemberPage = React.lazy(() => import('./contents/layoutPages/brands/setting/member'));
const BrandMemberEditPage = React.lazy(() => import('./contents/layoutPages/brands/setting/member/memberEdit'));
const BrandStoragePage = React.lazy(() => import('./contents/layoutPages/brands/setting/storage'));

const CafeDashboard = React.lazy(() => import('./contents/layoutPages/cafes/dashboard'));
const CafeDashboardNoticePage = React.lazy(() => import('./contents/layoutPages/cafes/dashboard/noticePage'));
const CafeDashboardManualPage = React.lazy(() => import('./contents/layoutPages/cafes/dashboard/manualPage'));

const CafeKioskContentsPage = React.lazy(() => import('@contents/layoutPages/cafes/contents'));
const CafeOrderKioskDetail = React.lazy(() => import('./contents/layoutPages/cafes/contents/management/orderKioskEdit'));
const CafePickupBoardDetail = React.lazy(() => import('./contents/layoutPages/cafes/contents/management/pickupBoardEdit'));
const CafeProductPage = React.lazy(() => import('./contents/layoutPages/cafes/product/product'));
const CafeProductDisplayDetail = React.lazy(() => import('./contents/layoutPages/cafes/product/product/display/detail'));
const CafeProductManageDetail = React.lazy(() => import('./contents/layoutPages/cafes/product/product/management/detail'));
const CafeCategoryPage = React.lazy(() => import('./contents/layoutPages/cafes/product/category'));
// const CafeCategoryDetail = React.lazy(() => import('@contents/layoutPages/cafes/product/category/display/detail'));
const CafeOptionPage = React.lazy(() => import('./contents/layoutPages/cafes/product/option'));
const CafeOptionDetail = React.lazy(() => import('./contents/layoutPages/cafes/product/option/detail'));
const CafeStockPage = React.lazy(() => import('./contents/layoutPages/cafes/product/stock'));
const CafeStockDetail = React.lazy(() => import('./contents/layoutPages/cafes/product/stock/mangement/detail'));
const CafeSaleStatisticsPage = React.lazy(() => import('./contents/layoutPages/cafes/sale/saleStatistics'));
const CafeBusinessStatisticsPage = React.lazy(() => import('./contents/layoutPages/cafes/sale/businessStatistics'));
const CafeSellingStatisticsPage = React.lazy(() => import('./contents/layoutPages/cafes/sale/sellingStatistics'));
const CafeManualPage = React.lazy(() => import('./contents/layoutPages/cafes/sale/manual'));

//V2::router
const CafeSaleStatisticsV2Page = React.lazy(() => import('./contents/layoutPages/cafes/saleV2/saleStatistics'));
const CafeSalesBusinessStatisticsV2Page = React.lazy(() => import('./contents/layoutPages/cafes/saleV2/businessStatistics'));
const CafeSalesSellingStatisticsV2Page = React.lazy(() => import('./contents/layoutPages/cafes/saleV2/sellingStatistics'));

const CafeCouponPage = React.lazy(() => import('./contents/layoutPages/cafes/couponSystem/coupon'));
const CafeStampPage = React.lazy(() => import('./contents/layoutPages/cafes/couponSystem/stamp'));
const CafeUseStatisticsPage = React.lazy(() => import('./contents/layoutPages/cafes/couponSystem/useStatistics'));
const CafeSettingBusinessPage = React.lazy(() => import('./contents/layoutPages/cafes/setting/business'));
const CafeSettingDevicePage = React.lazy(() => import('./contents/layoutPages/cafes/setting/device'));
const CafeSettingDeviceDetail = React.lazy(() => import('./contents/layoutPages/cafes/setting/device/detail'));
const CafeSettingMemberPage = React.lazy(() => import('./contents/layoutPages/cafes/setting/member'));
const CafeSettingMemberDetail = React.lazy(() => import('./contents/layoutPages/cafes/setting/member/detail'));
const CafeSettingStoragePage = React.lazy(() => import('./contents/layoutPages/cafes/setting/storage'));

const DinnerDashboard = React.lazy(() => import('@contents/layoutPages/dining/dashboard'));
const DinnerDashboardNoticePage = React.lazy(() => import('./contents/layoutPages/dining/dashboard/noticePage'));
const DinnerDashboardManualPage = React.lazy(() => import('./contents/layoutPages/dining/dashboard/manualPage'));

const DinnerKioskContentsPage = React.lazy(() => import('@contents/layoutPages/dining/contents'));
const DinnerKioskContentsEditPage = React.lazy(() => import('@contents/layoutPages/dining/contents/management/kioskEdit'));
const DinnerMenuContentsEditPage = React.lazy(() => import('@contents/layoutPages/dining/contents/management/menuEdit'));
const DinnerWayFindingContentsEditPage = React.lazy(() => import('@contents/layoutPages/dining/contents/management/wayFindingEdit'));
const DinnerTicketContentsEditPage = React.lazy(() => import('@contents/layoutPages/dining/contents/management/ticketEdit'));
const DinnerSatisfactionContentsEditPage = React.lazy(() => import('@contents/layoutPages/dining/contents/management/satisfactionEdit'));
const DinnerMenuPage = React.lazy(() => import('@contents/layoutPages/dining/diet/menu'));
const DinnerCoursePage = React.lazy(() => import('@contents/layoutPages/dining/diet/course'));
const DinnerCourseEditPage = React.lazy(() => import('@contents/layoutPages/dining/diet/course/CourseEdit'));
const DinnerOperationTimePage = React.lazy(() => import('@contents/layoutPages/dining/diet/operationTime'));
const DinnerOperationTimeEditPage = React.lazy(() => import('@contents/layoutPages/dining/diet/operationTime/operationTimeEdit'));
const DinnerReservationListPage = React.lazy(() => import('@contents/layoutPages/dining/mealQuantityReservation/reservationList'));
const DinnerMealQuantityReservationSettingPage = React.lazy(() => import('@contents/layoutPages/dining/mealQuantityReservation/setting'));
const DinnerSaleStatisticsPage = React.lazy(() => import('@contents/layoutPages/dining/sale/saleStatistics'));
const DinnerOrderManagePage = React.lazy(() => import('@contents/layoutPages/dining/sale/order'));
const DinnerBusinessStatisticsPage = React.lazy(() => import('@contents/layoutPages/dining/sale/businessStatistics'));
const DinnerManualPage = React.lazy(() => import('@contents/layoutPages/dining/sale/manual'));
const DinnerSaleManualDetailPage = React.lazy(() => import("@contents/layoutPages/dining/sale/manual/detail"));

//V2::router
const DinnerSalesV2StatisticsPage = React.lazy(() => import('@contents/layoutPages/dining/saleV2/saleStatistics'));
const DinnerSalesV2OrderManagePage = React.lazy(() => import('@contents/layoutPages/dining/saleV2/order'));
const DinnerSalesV2BusinessStatisticsPage = React.lazy(() => import('@contents/layoutPages/dining/saleV2/businessStatistics'));
const DinnerSalesV2UnsettledSalesPage = React.lazy(() => import('@contents/layoutPages/dining/saleV2/unsettledSales'));
const DinnerSalesV2UnsettledSalesDetailPage = React.lazy(() => import('@contents/layoutPages/dining/saleV2/unsettledSales/detail'));

const DinnerCouponPage = React.lazy(() => import('@contents/layoutPages/dining/couponSystem/coupon'));
const DinnerStampPage = React.lazy(() => import('@contents/layoutPages/dining/couponSystem/stamp'));
const DinnerUseStatisticsPage = React.lazy(() => import('@contents/layoutPages/dining/couponSystem/useStatistics'));
const DinnerSatisfactionSettingPage = React.lazy(() => import('@contents/layoutPages/dining/satisfaction/setting'));
const DinnerSatisfactionAppSettingPage = React.lazy(() => import('@contents/layoutPages/dining/satisfaction/appSetting'));
const DinnerSatisfactionStatisticsPage = React.lazy(() => import('@contents/layoutPages/dining/satisfaction/satisfactionStatistics'));
const DinnerSatisfactionStatisticsAppPage = React.lazy(() => import('@contents/layoutPages/dining/satisfaction/satisfactionStatisticsApp'));
const DinnerSettingBusinessPage = React.lazy(() => import('@contents/layoutPages/dining/setting/business'));
const DinnerSettingDevicePage = React.lazy(() => import('@contents/layoutPages/dining/setting/device'));
const DinnerSettingDeviceDetailPage = React.lazy(() => import('@contents/layoutPages/dining/setting/device/deviceDetail'));
const DinnerSettingMemberPage = React.lazy(() => import('@contents/layoutPages/dining/setting/member'));
const DinnerSettingMemberEditPage = React.lazy(() => import('@contents/layoutPages/dining/setting/member/memberEdit'));
const DinnerSettingStoragePage = React.lazy(() => import('@contents/layoutPages/dining/setting/storage'));

const Routes = () => {

    const introRoute: RouteObject = {
        path: '/main',
        children: [
            {
                index: true,
                element: <Navigate to="/auth/init"/>,
            },
        ]
    };

    const authRoutes: RouteObject = {
        path: '/auth',
        element: <SingleLayout/>,
        children: [
            {
                index: true,
                element: <Navigate to="/auth/init"/>,
            },
            {
                path: 'init',
                element: <InitPage/>
            },
            {
                path: 'login',
                element: <LoginPage/>,
            },
            {
                path: 'password-change',
                element: <PasswordChangePage/>,
                children: [
                    {path: ':result', element: <PasswordChangePage/>},
                ]
            },
            // {
            //     path: 'krafton',
            //     children: [
            //         {
            //             path: 'sso',
            //             element: <KraftonSsoLoginPage/>
            //         }
            //     ]
            // },
            {
                path: 'signup',
                element: <SignupPage/>,
            },
            {
                path: 'complete',
                element: <SignupCompletePage/>
            }
        ],
    };

    const landRoutes: RouteObject = {
        path: '/land',
        element: <SingleLayout/>,
        children: [
            {
                index: true,
                element: <LandingPage/>,
            },
            {
                path: 'invite',
                children: [
                    {index: true, element: <InvitePate/>,},
                    {path: ':mailCode', element: <InvitePate/>},
                ]
            },
        ],
    };

    const rootRoutes: RouteObject = {
        path: '/',
        element: <BaseLayout/>,
    };

    const myRoutes: RouteObject = {
        path: '/my',
        element: <SideBarLayout/>,
        children: [
            {
                index: true,
                element: <Navigate to="/op/dashboard"/>,
            },
            {
                path: 'menu',
                element: <MyMenu/>,
            },
            {
                path: 'shop',
                element: <MyShop/>,
            },
        ]
    };

    const commonRoutes: RouteObject = {
        path: '/common',
        element: <SideBarLayout/>,
        children: [
            {
                index: true,
                element: <Navigate to="/common/notice"/>,
            },
            {
                path: 'notice/:noticeId',
                element: <CommonNoticeDetailPage menuId={RouteUrl.common.notice.id}/>,
            }
        ]
    };

    const operationRoutes: RouteObject = {
    path: '/op',
    element: <SideBarLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/op/dashboard" />,
      },
      {
        path: 'dashboard',
        element: <OperationDashboard menuId={RouteUrl.operation.dashboard.id} />,
      },
      {
        path: 'space',
        children: [
          { index: true, element: <OperationSpaceBrandListPage menuId={RouteUrl.operation.space.space.id} /> },
          { path: ":brandCode",
            element: <OperationSpaceContextPage />,
            children: [
              { index: true, element: <OperationSpaceTabPage menuId={RouteUrl.operation.space.space.id} /> },
              { path: 'brand', element: <OperationSpaceBrandEditPage menuId={RouteUrl.operation.space.space.id} /> },
              { path: 'shop',
                children: [
                  { index: true, element: <OperationSpaceShopEditPage menuId={RouteUrl.operation.space.space.id} /> },
                  { path: ':shopId', element: <OperationSpaceShopEditPage menuId={RouteUrl.operation.space.space.id} /> }
                ]
              },
              { path: 'device',
                children: [
                  { index: true, element: <OperationSpaceDeviceEditPage menuId={RouteUrl.operation.space.space.id} /> },
                  { path: ':deviceId', element: <OperationSpaceDeviceEditPage menuId={RouteUrl.operation.space.space.id} /> },
                ]
              },
            ]
          }
        ]
      },
      {
        path: 'employee',
        children: [
          {
            index: true,
            element: <OperationPersonnelEmployeeBrandPage menuId={RouteUrl.operation.personnel.employee.id} />
          },
          {
            path: ':brandCode',
            element: <OperationPersonnelEmployeeHistoryPage menuId={RouteUrl.operation.personnel.employee.id} />,
          }
        ]
      },
      {
        path: 'statLog',
        children: [
          {
            index: true,
            element: <Navigate to="/op/statLog/statistics" />,
          },
          {
            path: 'statistics',
            element: <OperationStatisticPage menuId={RouteUrl.operation.statLog.statistics.id} />,
          },
          {
            path: 'log',
            element: <OperationLogPage menuId={RouteUrl.operation.statLog.log.id} />,
          }
        ]
      },
      {
        path: 'system',
        children: [
          {
            index: true,
            element: <Navigate to="/op/system/remote" />,
          },
          {
            path: 'remote',
            children: [
              { index: true, element: <OperationRemoteBrandListPage menuId={RouteUrl.operation.system.remote.id}  /> },
              {
                path: ':brandCode',
                element: <OperationSpaceContextPage />,
                children: [
                  {index: true, element: <OperationRemoteDeviceListPage menuId={RouteUrl.operation.system.remote.id}  />},
                  {
                    path: ':deviceId',
                    element: <OperationRemoteDeviceDetailPage menuId={RouteUrl.operation.system.remote.id}  />,
                  },
                ]
              }
            ]
          },
          {
            path: 'distribute',
            children: [
              {
                path: '',
                element: <OperationDistributePage menuId={RouteUrl.operation.system.distribute.id}/>,
                children: [
                  { index: true,
                    element: <OperationDistributeBrandListPage/>
                  },
                ]
              },
              {
                path: ':brandCode',
                element: <OperationDistributeDeviceListPage menuId={RouteUrl.operation.system.distribute.id}/>,
              },
              {
                path: 'file',
                children: [
                  {
                    index: true,
                    element: <Navigate to="/op/system/distribute/file/edit" />,
                  },
                  {
                    path: 'edit',
                    children: [
                      {index: true, element: <OperationFileEditPage menuId={RouteUrl.operation.system.distribute.id}/>},
                      {path: ':applicationId', element: <OperationFileEditPage menuId={RouteUrl.operation.system.distribute.id}/>}
                    ]
                  }
                ]
              },
            ]
          },
          {
            path: 'failure',
            element: <OperationFailurePage menuId={RouteUrl.operation.system.failure.id}  />,
          }
        ]
      },
      {
        path: 'board',
        children: [
          {
            index: true,
            element: <Navigate to="/op/board/notice" />,
          },
          {
            path: 'notice',
            children: [
              {
                index: true,
                element: <OperationNoticePage menuId={RouteUrl.operation.board.notice.id}  />,
              },
              {
                path: 'edit',
                children: [
                  {
                    index: true,
                    element: <OperationNoticeEditPage menuId={RouteUrl.operation.board.notice.id}  />,
                  },
                  {
                    path: ':noticeId',
                    element: <OperationNoticeEditPage menuId={RouteUrl.operation.board.notice.id}  />,
                  },
                ]
              },
            ]
          },
          {
            path: 'manual',
            children: [
              {
                index: true,
                element: <OperationManualPage menuId={RouteUrl.operation.board.manual.id}  />,
              },
              {
                path: 'edit',
                element: <OperationManualEditPage menuId={RouteUrl.operation.board.manual.id}  />,
              },
              {
                path: ':manualId',
                element: <OperationManualEditPage menuId={RouteUrl.operation.board.manual.id}  />,
              },
            ]
          }
        ]
      },
      {
        path: 'storage',
        element: <OperationStoragePage menuId={RouteUrl.operation.setting.storage.id}  />,
      },
    ],
  };

    const brandRoutes: RouteObject = {
        path: '/brand',
        element: <SideBarLayout/>,
        children: [
            {
                index: true,
                element: <Navigate to="/brand/dashboard"/>,
            },
            {
                path: 'dashboard',
                children: [
                    {
                        index: true,
                        element: <BrandDashboard menuId={RouteUrl.brand.dashboard.id}/>,
                    },
                    {
                        path: 'company',
                        element: <BrandDashboardCompanyStatePage menuId={RouteUrl.brand.dashboard.company.id}/>,
                    },
                    {
                        path: 'shop',
                        element: <BrandDashboardShopOperationStateMobilePage menuId={RouteUrl.brand.dashboard.shop.id}/>,
                    },
                    {
                        path: 'notice',
                        element: <BrandDashboardNoticePage menuId={RouteUrl.brand.dashboard.notice.id}/>,
                    },
                    {
                        path: 'manual',
                        element: <BrandDashboardManualPage menuId={RouteUrl.brand.dashboard.manual.id}/>,
                    }
                ]
            },
            {
                path: 'personnel',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/brand/personnel/employee"/>,
                    },
                    {
                        path: 'employee',
                        element: <BrandEmployeeContextPage/>,
                        children: [
                            {index: true, element: <BrandEmployeePage menuId={RouteUrl.brand.personnel.employee.id}/>},
                            {
                                path: 'validate',
                                element: <BrandEmployeeExcelValidatePage
                                    menuId={RouteUrl.brand.personnel.employee.id}/>,
                            },
                        ]
                    },
                    {
                        path: 'external',
                        children: [
                            {
                                index: true,
                                element: <BrandExternalPage menuId={RouteUrl.brand.personnel.external.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <BrandExternalEditPage menuId={RouteUrl.brand.personnel.external.id}/>,
                            },
                            {
                                path: ':externalId',
                                element: <BrandExternalEditPage menuId={RouteUrl.brand.personnel.external.id}/>,
                            },
                        ]
                    },
                    {
                        path: 'qr',
                        element: <BrandQrIdCardPage menuId={RouteUrl.brand.personnel.qr.id}/>,
                    }
                ]
            },
            {
                path: 'statistics',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/brand/statistics/sale"/>,
                    },
                    {
                        path: 'sale',
                        element: <BrandSaleStatisticsPage menuId={RouteUrl.brand.statistics.sale.id}/>,
                    },
                    {
                        path: 'employee',
                        element: <BrandEmployeeStatisticsPage menuId={RouteUrl.brand.statistics.employee.id}/>,
                    },
                ]
            },
            {
                path: 'point',
                children: [
                    {
                        index: true,
                        path: 'setting',
                        element: <BrandPointSettingPage menuId={RouteUrl.brand.point.setting.id}/>,
                    },
                    {
                        //개발 확인용: 강제 포인트 부여
                        index: true,
                        path: 'setting/:env',
                        element: <BrandPointSettingPage menuId={RouteUrl.brand.point.setting.id}/>,
                    },
                    {
                        path: 'manage',
                        children: [
                            {
                                index: true,
                                element: <BrandPointManagePage menuId={RouteUrl.brand.point.manage.id}/>,
                            },
                            {
                                path: 'history/:id',
                                element: <BrandPointHistoryDetailPage menuId={RouteUrl.brand.point.historyDetail.id}/>,
                            },
                            {
                                path: 'history/manual',
                                element: <BrandPointHistoryManualPage menuId={RouteUrl.brand.point.historyManual.id}/>,
                            },
                            {
                                path: 'history/excel/:step',
                                element: <BrandPointHistoryExcelPage menuId={RouteUrl.brand.point.historyExcelRaw.id}/>,
                            },
                            {
                                path: 'employee/:id',
                                element: <BrandPointEmployeeDetailPage menuId={RouteUrl.brand.point.employeeDetail.id}/>,
                            }
                        ]
                    },
                    // {
                    //     path: 'use',
                    //     element: <BrandPointUseStatisticsPage menuId={RouteUrl.brand.point.use.id}/>,
                    // },
                ]
            },
            {
                path: 'coupon',
                children: [
                    {
                        index: true,
                        element: <BrandCouponPage menuId={RouteUrl.brand.coupon.base.id}/>,
                    },
                    {
                        path: 'use',
                        element: <BrandCouponUseStatisticsPage menuId={RouteUrl.brand.coupon.use.id}/>,
                    },
                    {
                        path: 'setting',
                        element: <BrandCouponSettingPage menuId={RouteUrl.brand.coupon.setting.id}/>,
                    }
                ]
            },
            {
                path: 'stamp',
                children: [
                    {
                        index: true,
                        element: <BrandStampPage menuId={RouteUrl.brand.stamp.base.id}/>,
                    },
                    {
                        path: 'use',
                        element: <BrandStampUseStatisticsPage menuId={RouteUrl.brand.stamp.use.id}/>,
                    },
                    {
                        path: 'setting',
                        element: <BrandStampSettingPage menuId={RouteUrl.brand.stamp.setting.id}/>,
                    }
                ]
            },
            {
                path: 'board',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/brand/board/board"/>
                    },
                    {
                        path: 'edit',
                        element: <BrandBoardEditPage menuId={RouteUrl.brand.board.base.id}/>,
                    },
                    {
                        path: ':boardId',
                        element: <BrandBoardEditPage menuId={RouteUrl.brand.board.base.id}/>,
                    },
                    {
                        path: 'board',
                        children: [
                            {
                                index: true,
                                element: <BrandBoardPage menuId={RouteUrl.brand.board.base.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <BrandBoardEditPage menuId={RouteUrl.brand.board.base.id}/>,
                            },
                            {
                                path: ':boardId',
                                element: <BrandBoardEditPage menuId={RouteUrl.brand.board.base.id}/>,
                            },
                        ]
                    },
                    {
                        path: 'survey',
                        children: [
                            {
                                index: true,
                                element: <BrandSurveyPage menuId={RouteUrl.brand.board.survey.id}/>,
                            },
                            {
                                path: ':id',
                                element: <BrandSurveyDetailPage menuId={RouteUrl.brand.board.survey.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <BrandSurveyEditPage menuId={RouteUrl.brand.board.survey.id}/>,
                            },
                            {
                                path: 'edit/:id',
                                element: <BrandSurveyEditPage menuId={RouteUrl.brand.board.survey.id}/>,
                            }
                        ]
                    },
                    {
                        path: 'terms',
                        children: [
                            {
                                index: true,
                                element: <BrandTermsPage menuId={RouteUrl.brand.board.terms.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <BrandTermsEditPage menuId={RouteUrl.brand.board.terms.id}/>,
                            },
                            {
                                path: ':id',
                                element: <BrandTermsEditPage menuId={RouteUrl.brand.board.terms.id}/>,
                            }
                        ]
                    }
                ]
            },
            {
                path: 'setting',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/brand/setting/member"/>,
                    },
                    {
                        path: 'member',
                        children: [
                            {
                                index: true,
                                element: <BrandMemberPage menuId={RouteUrl.brand.setting.member.id}/>,
                            },
                            {
                                path: 'edit/:memberId',
                                element: <BrandMemberEditPage menuId={RouteUrl.brand.setting.member.id}/>,
                            },
                        ]
                    },
                    {
                        path: 'storage',
                        element: <BrandStoragePage menuId={RouteUrl.brand.setting.storage.id}/>,
                    }
                ]
            },
        ],
    };

    const cafeRoutes: RouteObject = {
        path: '/cafe',
        element: <SideBarLayout/>,
        children: [
            {
                index: true,
                element: <Navigate to="/cafe/dashboard"/>,
            },
            {
                path: 'dashboard',
                children: [
                    {
                        index: true,
                        element: <CafeDashboard menuId={RouteUrl.cafe.dashboard.id}/>,
                    },
                    {
                        path: 'notice',
                        element: <CafeDashboardNoticePage menuId={RouteUrl.cafe.dashboard.notice.id}/>,
                    },
                    {
                        path: 'manual',
                        element: <CafeDashboardManualPage menuId={RouteUrl.cafe.dashboard.manual.id}/>,
                    }
                ]
            },
            {
                path: 'contents',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/cafe/contents/orderKiosk"/>,
                    },
                    {
                        path: "orderKiosk",
                        children: [
                            {
                                index: true,
                                element: (<CafeKioskContentsPage menuId={RouteUrl.cafe.contents.orderKiosk.id}/>),
                            },
                            {
                                path: "edit",
                                children: [
                                    {
                                        index: true,
                                        element: <CafeOrderKioskDetail menuId={RouteUrl.cafe.contents.orderKiosk.id}/>,
                                    },
                                    {
                                        path: ":contentId",
                                        element: <CafeOrderKioskDetail menuId={RouteUrl.cafe.contents.orderKiosk.id}/>
                                    },
                                ]
                            },

                        ],
                    },
                    {
                        path: 'pickupBoard',
                        children: [
                            {
                                index: true,
                                element: (<CafeKioskContentsPage menuId={RouteUrl.cafe.contents.pickupBoard.id}/>
                                ),
                            },
                            {
                                path: "edit",
                                children: [
                                    {
                                        index: true,
                                        element: <CafePickupBoardDetail menuId={RouteUrl.cafe.contents.pickupBoard.id}/>
                                    },
                                    {
                                        path: ":contentId",
                                        element: <CafePickupBoardDetail menuId={RouteUrl.cafe.contents.pickupBoard.id}/>
                                    },
                                ]
                            },

                        ]
                    }
                ]
            },
            {
                path: 'product',
                children: [
                    {
                        children: [
                            {
                                index: true,
                                element: <CafeProductPage menuId={RouteUrl.cafe.product.base.id}/>,
                            },
                            {
                                path: ':tab',
                                element: <CafeProductPage menuId={RouteUrl.cafe.product.base.id}/>,
                            },
                            {
                                path: "display",
                                element: <CafeProductDisplayDetail menuId={RouteUrl.cafe.product.base.id}/>
                            },
                            {
                                path: "display/:id",
                                element: <CafeProductDisplayDetail menuId={RouteUrl.cafe.product.base.id}/>
                            },
                            {
                                path: "manage",
                                element: <CafeProductManageDetail menuId={RouteUrl.cafe.product.base.id}/>
                            },
                            {
                                path: "manage/:id",
                                element: <CafeProductManageDetail menuId={RouteUrl.cafe.product.base.id}/>
                            },
                        ]
                    },
                    {
                        path: 'category',
                        children: [
                            {
                                path: "",
                                element: <CafeCategoryPage menuId={RouteUrl.cafe.product.category.id}/>,
                            },
                            {
                                path: ":tab",
                                element: <CafeCategoryPage menuId={RouteUrl.cafe.product.category.id}/>,
                            },
                            {path: "edit/:id", element: <CafeStockDetail menuId={RouteUrl.cafe.product.stock.id}/>},
                        ]
                    },
                    {
                        path: 'option',
                        children: [
                            {
                                path: "",
                                element: <CafeOptionPage menuId={RouteUrl.cafe.product.option.id}/>,
                            },
                            {
                                path: ":tab",
                                element: <CafeOptionPage menuId={RouteUrl.cafe.product.option.id}/>,
                            },
                            {
                                path: "new/:optionType",
                                element: <CafeOptionDetail menuId={RouteUrl.cafe.product.option.id}/>
                            },
                            {
                                path: "edit/:optionId",
                                element: <CafeOptionDetail menuId={RouteUrl.cafe.product.option.id}/>
                            },
                        ]
                    },
                    {
                        path: 'stock',
                        children: [
                            {
                                path: "",
                                element: <CafeStockPage menuId={RouteUrl.cafe.product.stock.id}/>,
                            },
                            {
                                path: ":tab",
                                element: <CafeStockPage menuId={RouteUrl.cafe.product.stock.id}/>,
                            },
                            {path: "edit/:id", element: <CafeStockDetail menuId={RouteUrl.cafe.product.stock.id}/>},
                        ]
                    }
                ]
            },
            {
                path: 'sale',
                children: [
                    {
                        index: true,
                        element: <CafeSaleStatisticsPage menuId={RouteUrl.cafe.sale.base.id}/>,
                    },
                    {
                        path: 'business',
                        element: <CafeBusinessStatisticsPage menuId={RouteUrl.cafe.sale.business.id}/>,
                    },
                    {
                        path: 'selling',
                        element: <CafeSellingStatisticsPage menuId={RouteUrl.cafe.sale.selling.id}/>,
                    },
                    {
                        path: 'manual',
                        element: <CafeManualPage menuId={RouteUrl.cafe.sale.manual.id}/>,
                    }
                ]
            },
            {
                path: 'saleV2',
                children: [
                    {
                        index: true,
                        element: <CafeSaleStatisticsV2Page menuId={RouteUrl.cafe.saleV2.base.id}/>,
                    },
                    {
                        path: 'business',
                        element: <CafeSalesBusinessStatisticsV2Page menuId={RouteUrl.cafe.saleV2.business.id}/>,
                    },
                    {
                        path: 'selling',
                        element: <CafeSalesSellingStatisticsV2Page menuId={RouteUrl.cafe.saleV2.selling.id}/>,
                    }
                ]
            },
            {
                path: 'coupon',
                children: [
                    {
                        index: true,
                        element: <CafeCouponPage menuId={RouteUrl.cafe.coupon.base.id}/>,
                    },
                    {
                        path: 'stamp',
                        element: <CafeStampPage menuId={RouteUrl.cafe.coupon.stamp.id}/>,
                    },
                    {
                        path: 'use',
                        element: <CafeUseStatisticsPage menuId={RouteUrl.cafe.coupon.use.id}/>,
                    }
                ]
            },
            {
                path: 'setting',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/cafe/setting/business"/>,
                    },
                    {
                        path: 'business',
                        element: <CafeSettingBusinessPage menuId={RouteUrl.cafe.setting.business.id}/>,
                    },
                    {
                        path: 'device',
                        children: [
                            {
                                path: '',
                                element: <CafeSettingDevicePage menuId={RouteUrl.cafe.setting.device.id}/>,

                            },
                            {
                                path: ':deviceId',
                                element: <CafeSettingDeviceDetail menuId={RouteUrl.cafe.setting.device.id}/>,

                            }
                        ]
                    },
                    {
                        path: 'member',
                        children: [
                            {
                                path: '',
                                element: <CafeSettingMemberPage menuId={RouteUrl.cafe.setting.member.id}/>,

                            },
                            {
                                path: 'edit/:memberId',
                                element: <CafeSettingMemberDetail menuId={RouteUrl.cafe.setting.member.id}/>,

                            }
                        ]
                    },
                    {
                        path: 'storage',
                        element: <CafeSettingStoragePage menuId={RouteUrl.cafe.setting.storage.id}/>,
                    }
                ]
            },
        ],
    };

    const diningRoutes: RouteObject = {
        path: '/dining',
        element: <SideBarLayout/>,
        children: [
            {
                index: true,
                element: <Navigate to="/dining/dashboard"/>,
            },
            {
                path: 'dashboard',
                children: [
                    {
                        index: true,
                        element: <DinnerDashboard menuId={RouteUrl.dining.dashboard.id}/>,
                    },
                    {
                        path: 'notice',
                        element: <DinnerDashboardNoticePage menuId={RouteUrl.dining.dashboard.notice.id}/>,
                    },
                    {
                        path: 'manual',
                        element: <DinnerDashboardManualPage menuId={RouteUrl.brand.dashboard.manual.id}/>,
                    }
                ]
            },
            {
                path: 'contents',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/dining/contents/orderKiosk"/>,
                    },
                    {
                        path: 'orderKiosk',
                        children: [
                            {
                                index: true,
                                element: <DinnerKioskContentsPage menuId={RouteUrl.dining.contents.orderKiosk.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <DinnerKioskContentsEditPage menuId={RouteUrl.dining.contents.orderKiosk.id}/>,
                            },
                            {
                                path: ':contentId',
                                element: <DinnerKioskContentsEditPage menuId={RouteUrl.dining.contents.orderKiosk.id}/>,
                            }
                        ]
                    },
                    {
                        path: 'menuBoard',
                        children: [
                            {
                                index: true,
                                element: <DinnerKioskContentsPage menuId={RouteUrl.dining.contents.menuBoard.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <DinnerMenuContentsEditPage menuId={RouteUrl.dining.contents.menuBoard.id}/>,
                            },
                            {
                                path: ':contentId',
                                element: <DinnerMenuContentsEditPage menuId={RouteUrl.dining.contents.menuBoard.id}/>,
                            }
                        ],
                    },
                    {
                        path: 'wayFinding',
                        children: [
                            {
                                index: true,
                                element: <DinnerKioskContentsPage menuId={RouteUrl.dining.contents.wayFinding.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <DinnerWayFindingContentsEditPage
                                    menuId={RouteUrl.dining.contents.wayFinding.id}/>,
                            },
                            {
                                path: ':contentId',
                                element: <DinnerWayFindingContentsEditPage
                                    menuId={RouteUrl.dining.contents.wayFinding.id}/>,
                            }
                        ]
                    },
                    {
                        path: 'ticket',
                        children: [
                            {
                                index: true,
                                element: <DinnerKioskContentsPage menuId={RouteUrl.dining.contents.ticket.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <DinnerTicketContentsEditPage menuId={RouteUrl.dining.contents.ticket.id}/>,
                            },
                            {
                                path: ':contentId',
                                element: <DinnerTicketContentsEditPage menuId={RouteUrl.dining.contents.ticket.id}/>,
                            }
                        ]
                    },
                    {
                        path: 'satisfaction',
                        children: [
                            {
                                index: true,
                                element: <DinnerKioskContentsPage menuId={RouteUrl.dining.contents.satisfaction.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <DinnerSatisfactionContentsEditPage
                                    menuId={RouteUrl.dining.contents.satisfaction.id}/>,
                            },
                            {
                                path: ':contentId',
                                element: <DinnerSatisfactionContentsEditPage
                                    menuId={RouteUrl.dining.contents.satisfaction.id}/>,
                            }
                        ]
                    }
                ]
            },
            {
                path: 'diet',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/dining/diet/menu"/>,
                    },
                    {
                        path: 'menu',
                        element: <DinnerMenuPage menuId={RouteUrl.dining.diet.menu.id}/>,
                    },
                    {
                        path: 'course',
                        children: [
                            {
                                index: true,
                                element: <DinnerCoursePage menuId={RouteUrl.dining.diet.course.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <DinnerCourseEditPage menuId={RouteUrl.dining.diet.course.id}/>,
                            }
                        ]
                    },
                    {
                        path: 'operation',
                        children: [
                            {
                                index: true,
                                element: <DinnerOperationTimePage menuId={RouteUrl.dining.diet.operation.id}/>,
                            },
                            {
                                path: 'edit',
                                element: <DinnerOperationTimeEditPage menuId={RouteUrl.dining.diet.operation.id}/>,
                            }
                        ]
                    }
                ]
            },
            {
                path: 'meal',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/dining/meal/setting"/>,
                    },
                    {
                        path: 'setting',
                        element: <DinnerMealQuantityReservationSettingPage menuId={RouteUrl.dining.meal.setting.id}/>,
                    },
                    {
                        path: 'reservation',
                        element: <DinnerReservationListPage menuId={RouteUrl.dining.meal.reservation.id}/>,
                    }
                ]
            },
            {
                path: 'sale',
                children: [
                    {
                        index: true,
                        element: <DinnerSaleStatisticsPage menuId={RouteUrl.dining.sale.base.id}/>,
                    },
                    {
                        path: 'order',
                        element: <DinnerOrderManagePage menuId={RouteUrl.dining.sale.order.id}/>,
                    },
                    {
                        path: 'business',
                        element: <DinnerBusinessStatisticsPage menuId={RouteUrl.dining.sale.business.id}/>,
                    },
                    {
                        path: 'manual',
                        children: [
                            {index: true, element: <DinnerManualPage menuId={RouteUrl.dining.sale.manual.id}/>},
                            {
                                path: ':id',
                                element: <DinnerSaleManualDetailPage menuId={RouteUrl.dining.sale.manual.id}/>
                            }
                        ]
                    },
                ]
            },
            {
                path: 'saleV2',
                children: [
                    {
                        index: true,
                        element: <DinnerSalesV2StatisticsPage menuId={RouteUrl.dining.saleV2.base.id}/>,
                    },
                    {
                        path: 'order',
                        element: <DinnerSalesV2OrderManagePage menuId={RouteUrl.dining.saleV2.order.id}/>,
                    },
                    {
                        path: 'business',
                        element: <DinnerSalesV2BusinessStatisticsPage menuId={RouteUrl.dining.saleV2.business.id}/>,
                    },
                    {
                        path: 'unsettledSales',
                        children: [
                            {
                                index: true,
                                element: <DinnerSalesV2UnsettledSalesPage
                                    menuId={RouteUrl.dining.saleV2.unsettledSales.id}/>
                            },
                            {
                                path: ':id',
                                element: <DinnerSalesV2UnsettledSalesDetailPage
                                    menuId={RouteUrl.dining.saleV2.unsettledSales.id}/>
                            }
                        ]
                    }
                ]
            },
            {
                path: 'coupon',
                children: [
                    {
                        index: true,
                        element: <DinnerCouponPage menuId={RouteUrl.dining.coupon.base.id}/>,
                    },
                    {
                        path: 'stamp',
                        element: <DinnerStampPage menuId={RouteUrl.dining.coupon.stamp.id}/>,
                    },
                    {
                        path: 'use',
                        element: <DinnerUseStatisticsPage menuId={RouteUrl.dining.coupon.use.id}/>,
                    }
                ]
            },
            {
                path: 'satisfaction',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/dining/satisfaction/setting"/>,
                    },
                    {
                        path: 'setting',
                        element: <DinnerSatisfactionSettingPage menuId={RouteUrl.dining.satisfaction.setting.id}/>,
                    },
                    {
                        path: 'app',
                        element: <DinnerSatisfactionAppSettingPage menuId={RouteUrl.dining.satisfaction.app.id}/>,
                    },
                    {
                        path: 'statistics',
                        element: <DinnerSatisfactionStatisticsPage
                            menuId={RouteUrl.dining.satisfaction.statistics.id}/>,
                    },
                    {
                        path: 'statisticsApp',
                        element: <DinnerSatisfactionStatisticsAppPage
                            menuId={RouteUrl.dining.satisfaction.statisticsApp.id}/>,
                    }
                ]
            },
            {
                path: 'setting',
                children: [
                    {
                        index: true,
                        element: <Navigate to="/dining/setting/business"/>,
                    },
                    {
                        path: 'business',
                        element: <DinnerSettingBusinessPage menuId={RouteUrl.dining.setting.business.id}/>,
                    },
                    {
                        path: 'device',
                        children: [
                            {
                                index: true,
                                element: <DinnerSettingDevicePage menuId={RouteUrl.dining.setting.device.id}/>,
                            },
                            {
                                path: ':deviceId',
                                element: <DinnerSettingDeviceDetailPage menuId={RouteUrl.dining.setting.device.id}/>,
                            }
                        ]
                    },
                    {
                        path: 'member',
                        children: [
                            {
                                index: true,
                                element: <DinnerSettingMemberPage menuId={RouteUrl.dining.setting.member.id}/>,
                            },
                            {
                                path: 'edit/:memberId',
                                element: <DinnerSettingMemberEditPage menuId={RouteUrl.dining.setting.member.id}/>,
                            },
                        ]
                    },
                    {
                        path: 'storage',
                        element: <DinnerSettingStoragePage menuId={RouteUrl.dining.setting.storage.id}/>,
                    }
                ]
            },
        ],
    };

    const noMatchRoutes: RouteObject = {
        path: '*',
        element: <Navigate to="/"/>,
    };

    const routes: RouteObject[] = [
        introRoute,
        rootRoutes,
        noMatchRoutes,
        landRoutes,
        authRoutes,
        myRoutes,
        operationRoutes,
        brandRoutes,
        cafeRoutes,
        diningRoutes,
        commonRoutes
    ];

    return useRoutes(routes);
};

export default Routes;
